import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import SaberMas from '../Buttons/SaberMas';
import useThemes from '../../hooks/useThemes';
import useConfigs from '../../hooks/useConfigs';

const Card = ({ img, titulo, texto, onClick, ...props }) => {
  const { backgroundSeptimo, colorPrincipal, colorCuarto } = useThemes();
  const { fontSizeMultiplier } = useConfigs();

  return (
    <CardContainer
      {...props}
      background={backgroundSeptimo}
      color={colorPrincipal}
      colortipografia={colorCuarto}
      fontsizemultiplier={fontSizeMultiplier}
    >
      <div className='img-container'>
        <img src={img} alt={titulo} />
      </div>

      <div className='text-container'>
        <p className='titulo'>{titulo}</p>
        <p className='texto'>{texto}</p>
      </div>
      <div className='btn-container'>
        <SaberMas label='Saber más' onClick={onClick} />
      </div>
    </CardContainer>
  );
};

export default Card;

Card.propTypes = {
  img: PropTypes.string,
  titulo: PropTypes.string,
  texto: PropTypes.string,
  onClick: PropTypes.func,
};

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 50rem;
  min-width: 30rem;
  border-radius: 4rem;
  overflow: hidden;
  box-shadow: 0px 0px 5px #808080;
  background-color: ${(props) => props.background};

  .img-container {
    height: 55%;
    border-radius: 0px 0px 400px 36px / 40px 40px 78px 28px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .text-container {
    margin-top: 1rem;
    padding: 1rem;
    text-align: center;

    .titulo {
      font-size: ${(props) => 30 * props.fontsizemultiplier};
      line-height: 3rem;
      font-weight: 700;
      color: ${(props) => props.color};
    }

    .texto {
      font-size: ${(props) => 15 * props.fontsizemultiplier};
      color: ${(props) => props.colortipografia};
      padding: 0 2rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      line-clamp-: 3;
      overflow: hidden !important;
    }
  }

  .btn-container {
    margin-top: auto;
  }
`;
